<template>
    <div class="body">
        <div class="title" v-if="isTitle">
            <div class="title-logo" v-if="isDefault"></div>
            <div class="title-logo-tri" v-else></div>
            <div
                class="subtitle"
                :style="{ fontSize: getFontSize }"
            >{{title}}</div>
        </div>
        <div class="intr">
            {{intrLimited}}<span class="detail" v-if="isLimited"  @click="showPopup">查看详情</span>
        </div>

        <!-- 弹出层 -->
        <van-popup
            class="detail-content"
            v-model:show="show"
            round
            position="bottom"
            :style="{ backgroundImage:'url(' + imgMap.get('back') + ')' }"
            v-html="intr"
        />
    </div>
</template>

<script>
import { ref, toRefs } from 'vue'
import { ellipsisString } from '@/utils/stringUtils'

export default {
    name: 'Introduction',
    props: {
        title: {
            type: String,
            default: () => ''
        },
        intr: {
            type: String
        },
        limit: {
            type: Number,
            default: 110
        },
        logoType: {
            type: Number,
            default: 1
        }
    },
    setup(props) {
        // // init intr
        // const { intr, limit } = toRefs(props)
        // const intrLimited = ellipsisString(intr.value, limit.value)

        // init isLimited
        // const isLimited = ref(false)
        // const { intr, limit } = toRefs(props)
        // if(intr.value.length > limit.value ) isLimited.value = true

        // init config
        let isDefault = true
        const { logoType } = toRefs(props)
        if(logoType.value == 2 ) isDefault = false

        let isTitle = true
        const { title } = toRefs(props)
        if(title.value == '') isTitle = false

        // init popup
        const show = ref(false);
        const showPopup = () => {
            show.value = true;
        };

        // init popup background
        const baseUrl = '/resource/components/'
        let imgMap = new Map([
            ['back', 'back.png']
        ])
        imgMap.forEach((value, key) => {
            value = baseUrl + value
            imgMap.set(key, value)
        })

        return {
            isDefault,
            isTitle,
            show,
            imgMap,
            showPopup
            }
    },
    computed:{
        isLimited(){
            return this.intr && this.intr.length > this.limit
        },
        intrLimited() {
            if(this.isLimited){
                return ellipsisString(this.intr, this.limit)
            }
            return this.intr
        },
        getFontSize() {
            return this.isDefault? '18px' : '15px'
        }
    }
}
</script>

<style scoped>
.body {
    position: relative;
    margin: 10px 0;
}

.title {
    margin-bottom: 10px;
    display: flex;
}

.title-logo {
    width: 8px;
    height: 25px;
    background: #4FADF8;
    border-radius: 5px;
    margin-right: 10px;
}

.title-logo-tri {
    border: 8px solid #fff;
    border-left: 12px solid #3BA0E8;
    width: 0;
    height: 0;
    margin-top: 2.5px;
}

.intr {
    font-size: 14px;
    color: #4E4E4E;
}

.detail {
    /*position: absolute;*/
    /*right: 0;*/
    /*bottom: 0;*/
    color: #4FADF8;
    font-size: 14px;
}
</style>

<style>
.detail-content {
    height: 60vh;
    widows: 100%;
    padding: 10px;
    box-sizing: border-box;
    padding: 40px 20px;
    color: #4E4E4E;
    background-size: 100%;
    background-position-y: center;
    background-repeat: no-repeat;
}
</style>
